export function injectGAScript(gaId: string): void {
  if (!gaId) return;

  const existingScript = document.querySelector(`script[src*="${gaId}"]`);
  if (existingScript) return; // Prevent duplicate injection

  const externalScript = document.createElement('script');
  externalScript.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
  externalScript.async = true;
  document.head.appendChild(externalScript);

  const inlineScript = document.createElement('script');
  inlineScript.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${gaId}');
  `;
  document.head.appendChild(inlineScript);
}